import styled, { css } from 'styled-components';
export const BubbleText = styled.div`
  color: ${props => props.error ? '#D9575E' : '#00003d'};
  font-weight: 500;
  font-size: 13px;
  word-break: break-word;
  padding: 3px 0 3px 8px;

  ${props => props.readonly && css`
      padding: 3px 8px;
    `}
`;
export const BubbleWrapper = styled.div`
  display: inline-block;
`;
export const Bubble = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${props => props.error ? 'rgba(217, 87, 94, 0.2)' : 'rgba(0, 0, 61, 0.1)'};
  border-radius: 4px;
  padding: 0;
  margin: 4px 2px;
  cursor: default;

  & path {
    transition: stroke 0.2s ease-out;
    stroke: ${props => props.error ? 'rgba(217, 87, 94, 0.5)' : 'rgba(0, 0, 61, 0.5)'};
  }

  &:hover path {
    stroke: ${props => props.error ? 'rgba(217, 87, 94, 0.75)' : 'rgba(0, 0, 61, 0.75)'};
  }
`;
export const CrossWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
`;
export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  border-radius: 0 4px 4px 0;
  transition: background-color ease-out 0.2s;
  cursor: pointer;

  &:hover {
    background: ${props => props.error ? 'rgba(217, 87, 94, 0.1)' : 'rgba(0, 0, 61, 0.1)'};

    &:hover path {
      stroke: ${props => props.error ? 'rgba(217, 87, 94, 1)' : 'rgba(0, 0, 61, 1)'};
    }
  }
`;